export default __webpack_public_path__ + "static/media/pro-elevate-bbl-2.36688854.png";